import React from 'react';
import SVG from '@newrelic/gatsby-theme-newrelic/src/components/SVG';

const MongoDBIcon = (props) => {
  return (
    <SVG {...props} viewBox="0 0 32 32">
      <g fill="none" fillRule="evenodd">
        <path
          d="M16.449 29.429l-.72-.248s.088-3.689-1.228-3.954c-.877-1.024.141-43.423 3.299-.14 0 0-1.088.546-1.28 1.482-.211.918-.071 2.86-.071 2.86z"
          fill="#FFF"
        />
        <path
          d="M16.449 29.429l-.72-.248s.088-3.689-1.228-3.954c-.877-1.024.141-43.423 3.299-.14 0 0-1.088.546-1.28 1.482-.211.918-.071 2.86-.071 2.86z"
          fill="#A6A385"
        />
        <path
          d="M17.078 25.771s6.141-4.205 4.704-12.955C20.397 6.455 17.13 4.37 16.77 3.568 16.376 2.998 16 2 16 2l.257 17.695c0 .018-.53 5.417.821 6.076"
          fill="#FFF"
        />
        <path
          d="M17.078 25.771s6.141-4.205 4.704-12.955C20.397 6.455 17.13 4.37 16.77 3.568 16.376 2.998 16 2 16 2l.257 17.695c0 .018-.53 5.417.821 6.076"
          fill="#499D4A"
        />
        <path
          d="M15.316 25.771s-5.636-4.047-5.302-11.173c.318-7.126 4.299-10.627 5.068-11.26.502-.564.519-.775.552-1.338.351.792.285 11.842.335 13.144.15 5.014-.268 9.678-.653 10.627z"
          fill="#FFF"
        />
        <path
          d="M15.316 25.771s-5.636-4.047-5.302-11.173c.318-7.126 4.299-10.627 5.068-11.26.502-.564.519-.775.552-1.338.351.792.285 11.842.335 13.144.15 5.014-.268 9.678-.653 10.627z"
          fill="#58AA50"
        />
      </g>
    </SVG>
  );
};

export default MongoDBIcon;
